const cafe = {
    default: {
        sa: {
            source: "sa.es6.vn",
            extensionId: "pcabkkkdjcfmkbncnflogcjakoiknhhd"
        },
    },
};
const df = cafe.default;

export default {
    sa: (state) => {
        let sprt = state.list.find(
            item =>
                item.source === df.sa.source
                && item.extensionId === df.sa.extensionId
        );
        return sprt;
    },
    // sa2: (state) => (id) => {
    //     return state.list[0];
    // },
};



// WEBPACK FOOTER //
// src/store/supporter/getters.js